import type { Employee } from '@momentum/types';
import type { EditableFact } from '../../shared/types';
import type { MatchPointSession } from '../../deep-dive-stage/types/deepDive.types';
import { LeaderColumn } from './LeaderColumn';
import { ParticipantColumn } from './ParticipantColumn';

interface LessonsMatrixProps {
  leader: Employee;
  participants: Employee[];
  session: MatchPointSession;
  fact: EditableFact | null;
  onEditLesson: (lessonIndex: number, lesson: string) => void;
  onDeleteLesson: (lessonIndex: number) => void;
  onAddLesson: (lesson: string) => void;
}

export function LessonsMatrix({
  leader,
  participants,
  session,
  fact,
  onEditLesson,
  onDeleteLesson,
  onAddLesson,
}: LessonsMatrixProps) {
  return (
    <div className="flex-1 overflow-x-auto overflow-y-auto pb-10">
      <div className="flex h-max min-h-full px-8 pt-6 gap-6 w-max pb-24">
        <LeaderColumn
          leader={leader}
          session={session}
          fact={fact}
          onEditLesson={onEditLesson}
          onDeleteLesson={onDeleteLesson}
          onAddLesson={onAddLesson}
        />
        {participants.map((participant) => (
          <ParticipantColumn key={participant._id} participant={participant} />
        ))}
      </div>
    </div>
  );
}
